import React, {Fragment, useReducer} from 'react';
import {connect} from "react-redux";
import AllFeaturesChecker from "../../../../../../../visComponents/allFeaturesChecker";
import {getCurrentLayout} from "../../../../../../../appLayout";
import {getNavItems} from "../../../../../../helpers/sqftHelperUi";
import FeatureThumbnail from "../../../../../../../visComponents/featureThumbnail";
import {setSelectedFeature} from "../../../../../../../../actions/sqftResourceFunctions";
import PropTypes from "prop-types";
import crownMoldingCanvas from "../../../../../canvas/core/controls/crownmoldingCanvas";

const SqftOptionsCrown = (props) => {
  const {setSelectedFeature} = props;
  const {partId} = props;
  const [activeItem, setActiveItem] = React.useState(0);
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const handleButtonClick = function(e, feature) {
    void e;
    setActiveItem(feature);
    setSelectedFeature(feature);
    crownMoldingCanvas.setHighlighting(false);
    crownMoldingCanvas.setCursorImage();
  };

  const layout = getCurrentLayout();
  const featureGroup = layout.getSubPartFromQtCategories(partId);
  const navItems = getNavItems(featureGroup, '', {}, true, true);

  return (
    <Fragment>
      {
        featureGroup && featureGroup.part && !featureGroup.part.allFeaturesReceived
          ? <AllFeaturesChecker subPart={featureGroup} callBack={() => forceUpdate(1)} loaderOnly={true}/>
          : navItems.map((navItem, index) => {
            const className = activeItem && (activeItem.part.dbFeature.id === navItem.part.dbFeature.id) ? 'lightbox-option-single lightbox-option-selected' : 'lightbox-option-single';

            return (
              <div className={className} key={index}
                   onClick={(e) => handleButtonClick(e, navItem)}>
                <div className="upper-image">
                  <FeatureThumbnail feature={navItem.part}/>
                </div>
                <div className="upper-content">
                  <div className="lightbox-description-text-rectangular">

                  </div>
                </div>
              </div>
            )
          })
      }

    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  return {
    menuOpened
  };
};

const mapDispatchToProps = {
  setSelectedFeature
};

SqftOptionsCrown.propTypes = {
  partId: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftOptionsCrown);
